// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"96dcf2f4","320":"749fa09a","453":"a1270177","905":"c2753317"}[chunkId] + ".chunk.js";
};